$(document).ready(function () {
  function visitor() {
    //瀏覽人次
    $.ajax({
      url: `${host}api/v1/Web/VisitInfo`,
      type: "GET",
      headers: {
        Accept: "application/json",
      },
      success: function (data) {
        if (!data.Error) {
          let result = data.Result;
          for (let key in result) {
            $(`.${key}`).text(result[key]);
          }
        }
      },
    });
  }
  function setCookie(c_name, value, exdays) {
    let now = moment().format("YYYY-MM-DD :00:00");
    let exdate = new Date(now);
    exdate.setDate(exdate.getDate() + exdays);
    let c_value =
      escape(value) +
      (exdays == null ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
  }

  function getCookie(c_name) {
    let c_value = document.cookie;
    let c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) {
      c_start = c_value.indexOf(c_name + "=");
    }
    if (c_start == -1) {
      c_value = null;
    } else {
      c_start = c_value.indexOf("=", c_start) + 1;
      let c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
  }

  checkSession();

  async function checkSession() {
    let c = getCookie("visited");
    if (c === "yes") {
      // alert("Welcome back!");
    } else {
      setCookie("visited", "yes", 1);
      let res = await $.ajax({
        url: `${host}api/v1/Web/AddVisit`,
        type: "POST",
        headers: {
          Accept: "application/json",
        },
        success: function (data) {
        },
      });
    }
    await visitor();
  }
});
